import { computed, ref } from 'vue'

const STORAGE_KEY = 'dss_sidebar_pinned'

function loadPinned() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
  }
  catch {
    return []
  }
}

function flattenLeafItems(items, ancestors = []) {
  return items.reduce((accumulator, item) => {
    if (item.separator)
      return accumulator
    if (item.hasChildren && item.children?.length) {
      accumulator.push(...flattenLeafItems(item.children, [...ancestors, item.label]))
    }
    else {
      accumulator.push(ancestors.length > 0 ? { ...item, breadcrumb: ancestors } : item)
    }
    return accumulator
  }, [])
}

function getItemKey(item) {
  if (!item.originalKey)
    return null
  if (typeof item.originalKey === 'object')
    return JSON.stringify(item.originalKey)
  return String(item.originalKey)
}

export function usePinnedItems() {
  const pinnedKeys = ref(loadPinned())

  function isPinned(item) {
    const key = getItemKey(item)
    return key !== null && pinnedKeys.value.includes(key)
  }

  function togglePin(item) {
    const key = getItemKey(item)
    if (key === null)
      return
    if (pinnedKeys.value.includes(key)) {
      pinnedKeys.value = pinnedKeys.value.filter(k => k !== key)
    }
    else {
      pinnedKeys.value = [...pinnedKeys.value, key]
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(pinnedKeys.value))
    }
    catch {}
  }

  function buildPinnedItems(allItems) {
    return computed(() => {
      if (!pinnedKeys.value.length)
        return []
      return flattenLeafItems(allItems.value).filter(item => isPinned(item))
    })
  }

  return { isPinned, togglePin, buildPinnedItems }
}
